
import { defineComponent, reactive } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Reset Password Completed",
  props: {
    userName: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const state = reactive({
      userName: props.userName,
    });

    const {t} = useI18n();

    return { state, t };
  },
});
